import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "video-container"
}
const _hoisted_2 = {
  key: 1,
  class: "declaration-container"
}
const _hoisted_3 = {
  key: 3,
  class: "button-container"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ActionHeader = _resolveComponent("ActionHeader")!
  const _component_Video = _resolveComponent("Video")!
  const _component_TranslatedText = _resolveComponent("TranslatedText")!
  const _component_Declaration = _resolveComponent("Declaration")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Signature = _resolveComponent("Signature")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_ActionHeader, {
      hotspotDescription: _ctx.hotspotDescription,
      actionTitle: _ctx.actionTitle,
      actionDescription: _ctx.actionDescription
    }, null, 8, ["hotspotDescription", "actionTitle", "actionDescription"]),
    (!_ctx.isLoading && _ctx.videoData && _ctx.videoData.id && _ctx.currentVideoSource)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_Video, {
            reference: _ctx.currentVideo.reference,
            videoType: _ctx.currentVideoType,
            format: "video/mp4",
            videoSource: _ctx.currentVideoSource,
            placeholderUrl: _ctx.placeholderUrl,
            onEnded: _ctx.handleVideoEnded
          }, null, 8, ["reference", "videoType", "videoSource", "placeholderUrl", "onEnded"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.actionProgress?.completed && !_ctx.viewOnly)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_TranslatedText, {
            path: _ctx.signatureEnabled ? 'action.signed' : 'action.viewed'
          }, null, 8, ["path"]),
          _cache[4] || (_cache[4] = _createTextVNode(" - ", -1)),
          _createElementVNode("span", null, _toDisplayString(_ctx.completionDateString), 1)
        ]))
      : _createCommentVNode("", true),
    (!_ctx.wetSignature && _ctx.signatureEnabled && _ctx.readyToSign && !_ctx.viewOnly)
      ? (_openBlock(), _createBlock(_component_Declaration, {
          key: 2,
          modelValue: _ctx.declaration,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.declaration) = $event)),
          isValid: _ctx.declarationIsValid,
          "onUpdate:isValid": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.declarationIsValid) = $event)),
          line1: '',
          consentText: 'declaration.sign-label'
        }, null, 8, ["modelValue", "isValid"]))
      : _createCommentVNode("", true),
    (_ctx.signatureEnabled && _ctx.readyToSign && !_ctx.viewOnly)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_component_Button, {
            text: "declaration.submit",
            size: "sm",
            onClick: _ctx.handleSignClick,
            disabled: _ctx.wetSignature && _ctx.showSign
          }, null, 8, ["onClick", "disabled"])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_Modal, {
      modelValue: _ctx.showSignModal,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.showSignModal) = $event)),
      title: "signature.title",
      showFooter: false,
      onCancel: _ctx.handleModalHide
    }, {
      default: _withCtx(() => [
        _createVNode(_component_Signature, {
          modelValue: _ctx.declarationWet,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.declarationWet) = $event)),
          onConfirm: _ctx.handleSignSubmit,
          onCancel: _ctx.handleModalHide
        }, null, 8, ["modelValue", "onConfirm", "onCancel"])
      ]),
      _: 1
    }, 8, ["modelValue", "onCancel"])
  ]))
}